export default __webpack_public_path__ + "static/media/ETEF-23-24.21d5b66e.pdf";